import { Component, ViewContainerRef, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { Spinkit } from 'ng-http-loader';
@Component({
    selector: 'app-root',
  templateUrl: './app.component.html',
     styleUrls: ['../../node_modules/@telerik/kendo-theme-default/dist/all.css']
})
export class AppComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  title = 'angular-signalr-crud';
  loginLinkText: string = "Logout";
  public spinkit = Spinkit;
  constructor(private router: Router, private msalService: MsalService,private ngZone:NgZone) {
    if (!this.isUserLoggedIn()) {
      this.loginLinkText = "Login";
    }
    }

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
          .subscribe(() => window.scrollTo(0, 0));

    
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
  login() {
    this.msalService.loginPopup().subscribe((response: AuthenticationResult) => {
      this.msalService.instance.setActiveAccount(response.account);
      //response.accessToken

    })
  }
  logout() {
    this.msalService.logout();
  }
  isUserLoggedIn(): boolean {
    if (this.msalService.instance.getActiveAccount() != null) {
      return true;
    }
    return false;
  }



}
